import { Spinner } from "@chakra-ui/react";
import { Icon } from "assets/Icon";
import { generatePdf } from "components/RFQ/PdfDownloadButton";
import { useCurrentUser } from "hooks/auth";
import { Button } from "newui/components/Button";
import Tooltip from "newui/components/Tooltip";
import { useState } from "react";
import { ResponsePdfDownloadButtonProps } from "./types";

export const ResponsePdfDownloadButton = ({
	isLoading,
	rfxId,
	submissionId,
}: ResponsePdfDownloadButtonProps) => {
	const { isGuest } = useCurrentUser();
	const [isPdfLoading, setIsPdfLoading] = useState(false);

	const downloadResponsePdf = () => {
		setIsPdfLoading(true);

		generatePdf(
			"responses",
			rfxId,
			submissionId,
			isGuest
		).finally(() => setIsPdfLoading(false));
	};
	return (
		<Tooltip
			label={
				"Download a PDF version of your submission to see how it will look"
			}
		>
			<Button
				type="button"
				btntype="secondary"
				disabled={isPdfLoading || isLoading}
				onClick={downloadResponsePdf}
				data-testid="pdf-response-button"
				className="!text-xs"
			>
				<Icon
					icon="download"
					className="pr-2"
				/>
				{isPdfLoading && <Spinner className="mr-2" />}
				{isPdfLoading ? "Generating, please wait..." : "Download Response PDF"}
			</Button>
		</Tooltip>
	);
};
